import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconImageWithText32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconImageWithText32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7 8h18a2 2 0 0 1 2 2v10.962l-8.732-2.425-.45-.125-.385.264L9.69 24H7a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2m19.732 14.964.018.004A2 2 0 0 1 25 24H13.22l4.962-3.412zM25 26H7a4 4 0 0 1-4-4V10a4 4 0 0 1 4-4h18a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4m-2-12.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m2 0a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0M8 10a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2zm-1 5a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1m1 3a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconImageWithText32);
